<template>
  <div style="position: relative">
    <v-textarea
      outlined
      :value="value"
      :label="model.title"
      :error-messages="error"
      :hide-details="config.hideDetails || false"
      :readonly="readonly"
      :disabled="disabled"
      :dense="model.opts && model.opts.includes('dense')"
      :auto-grow="model.opts && model.opts.includes('auto-grow')"
      :placeholder="model.placeholder"
      :persistent-placeholder="!!model.placeholder || false"
      :rows="model.rows || 5"
      @input="$emit('input', $event)"
    />
    <v-btn small icon color="primary" style="position: absolute; top: 5px; right: 15px" @click="dialog = true">
      <v-icon>mdi-code-tags</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense flat color="primary" dark>
          <v-btn icon @click="closeEditor">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Редактор кода</v-toolbar-title>
          <v-spacer />
          <v-btn text @click="applyChanges">Сохранить</v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="flex: 1 1 auto; display: flex">
          <a-input-base-monaco-editor v-if="dialog" v-model="tempValue" :language="model.codeLang" ref="editor" style="flex: 1 1 auto; width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    values: Object,
    model: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {} },
  },
  data() {
    return {
      dialog: false,
      tempValue: "",
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.tempValue = this.value;
      }
    },
  },
  computed: {
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
  },
  methods: {
    closeEditor() {
      this.dialog = false;
    },
    applyChanges() {
      const v = this.$refs.editor.editor.getValue();
      this.$emit("input", v);
      this.dialog = false;
    },
  },
};
</script>
